export default {
  APP_API: process.env.VUE_APP_API,
  APP_API_ROOT: process.env.APP_API_ROOT,
  APP_URL: process.env.VUE_APP_URL,
  APP_UPLOAD: process.env.VUE_APP_UPLOAD,
  APP_BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
  APP_VIETNAM_ID: process.env.VUE_VIETNAM_ID,
  APP_LOCALE: process.env.VUE_APP_I18N_LOCALE || "vi",
  APP_FALLBACK_LOCALE: process.env.FALLBACK_LOCALE | ["en"],
  APP_MAX_CONNECTION_TIME: process.env.VUE_MAX_CONNECTION_TIME || 5000,
};
